import Prakarsa1 from '../Jaya Prakarsa/Jaya Prakarsa (1).webp'
import Prakarsa2 from '../Jaya Prakarsa/Jaya Prakarsa (2).webp'
import Prakarsa3 from '../Jaya Prakarsa/Jaya Prakarsa (3).webp'
import Prakarsa4 from '../Jaya Prakarsa/Jaya Prakarsa (4).webp'
import Prakarsa5 from '../Jaya Prakarsa/Jaya Prakarsa (5).webp'
import Prakarsa6 from '../Jaya Prakarsa/Jaya Prakarsa (6).webp'


const Prakarsaimages =[
Prakarsa1,Prakarsa2,Prakarsa3,Prakarsa4,Prakarsa5,Prakarsa6
]

export default Prakarsaimages;